module.exports = {"delete":"Delete","reemail":"Re-email","reprint":"Reprint","releaseOptions":"Release Options","release":"Release and","releasePart2":"no refund","releaseRefund":"Release and Refund","released":"Released","refunded":"Refunded","deleteTitle":"Delete ticket","deleteDescription":"Are you sure you want to delete that ticket?","releaseTitle":"Release ticket","releaseDescription":"Are you sure you want to release that ticket?","discountApplied":"Discount applied: ","flexpassUsed":"Flex Pass Redemption: ","flexpassTx":"Flex Pass TX: "}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResultsTicket/locales/en.json
// module id = 1419
// module chunks = 0